// File: src/theme/GlobalStyles.ts
// Purpose: Theme and styling-related file

import { createGlobalStyle } from "styled-components";
// import 'react-spring-bottom-sheet/dist/style.css';

export const GlobalStyles = createGlobalStyle`
  /* Global Reset */
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  /* Responsive Font Sizing */
  html {
    font-size: 16px;
    scroll-behavior: smooth;

    @media (max-width: 1024px) {
      font-size: 15px; /* Slightly smaller for tablets */
    }
    
    @media (max-width: 768px) {
      font-size: 14px; /* Mobile optimized */
    }
  }

  /* Body Styles */
  body {
    font-family: ${({ theme }) => theme.typography.default.fontFamily};
    font-size: ${({ theme }) => theme.typography.default.fontSize};
    line-height: ${({ theme }) => theme.typography.default.lineHeight};
    font-weight: ${({ theme }) => theme.typography.default.fontWeight};
    color: ${({ theme }) => theme.colors.textPrimary};
    background: ${({ theme }) => theme.colors.background};
    transition: ${({ theme }) => theme.transitions.default};
  }

  /* Typography */
  h1, h2, h3, h4, h5, h6 {
    font-weight: 600;
    line-height: 1.2;
  }

  p {
    font-size: 1rem;
    margin-bottom: 1rem;
  }

  /* Responsive Container */
  .container {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 16px;

    @media (max-width: 1024px) {
      max-width: 960px;
    }

    @media (max-width: 768px) {
      max-width: 100%;
      padding: 0 12px;
    }
  }

  /* Links */
  a {
    text-decoration: none;
    color: ${({ theme }) => theme.linkText};
    transition: color 0.2s ease-in-out;

    &:hover {
      color: ${({ theme }) => theme.primary};
    }
  }

  /* Buttons */
  button {
    font-family: inherit;
    cursor: pointer;
    border: none;
    outline: none;
    padding: 12px 20px;
    border-radius: 6px;
    font-size: 1rem;
    font-weight: 600;
    background-color: ${({ theme }) => theme.primary};
    color: ${({ theme }) => theme.buttonText};
    transition: background-color 0.3s ease-in-out;

    &:hover {
      background-color: ${({ theme }) => theme.primarySelected};
    }

    &:disabled {
      background-color: ${({ theme }) => theme.buttonDisabledBackground};
      color: ${({ theme }) => theme.buttonDisabledText};
      cursor: not-allowed;
    }

    @media (max-width: 768px) {
      padding: 10px 16px;
      font-size: 0.9rem;
    }
  }

  /* Forms & Inputs */
  input, textarea {
    font-family: inherit;
    width: 100%;
    padding: 12px;
    border-radius: 6px;
    border: 1px solid ${({ theme }) => theme.inputBorder};
    background-color: ${({ theme }) => theme.inputBackground};
    color: ${({ theme }) => theme.inputText};
    transition: border-color 0.2s ease-in-out;

    &:focus {
      border-color: ${({ theme }) => theme.inputFocusedBorder};
      outline: none;
    }

    @media (max-width: 768px) {
      padding: 10px;
    }
  }

  /* Responsive Grid */
  .grid {
    display: grid;
    gap: 20px;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));

    @media (max-width: 1024px) {
      gap: 16px;
    }

    @media (max-width: 768px) {
      gap: 12px;
      grid-template-columns: 1fr;
    }
  }

  /* Dark Mode Support */
  @media (prefers-color-scheme: dark) {
    body {
      background-color: ${({ theme }) => theme.background};
      color: ${({ theme }) => theme.textPrimary};
    }
  }
`;